// Module
var code = "<script id=\"wcc-components-video-overlay-stage\" type=\"text/template\">\r\n    <div data-bind=\"visible: isReady\">\r\n        <video class=\"video-js vjs-default-skin vjs-big-play-centered\" controls data-bind=\"dom: videoNode\" />\r\n    </div>\r\n\r\n    <wcs-spinner params=\"visible: !isReady()\"></wcs-spinner>\r\n</script>";
// Exports
module.exports = code;